export const NAME = 'mycashback';

export const RECEIVE_ACCOUNT_PURCHASES = 'RECEIVE_ACCOUNT_PURCHASES';
export const REQUEST_ACCOUNT_PURCHASES = 'REQUEST_ACCOUNT_PURCHASES';
export const FAILURE_ACCOUNT_PURCHASES = 'FAILURE_ACCOUNT_PURCHASES';



// WEBPACK FOOTER //
// ./src/services/account/cashback/constants.js